"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EmptyCustomMapper_1 = require("./EmptyCustomMapper");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return EmptyCustomMapper_1.default; } });
